
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adestra",
      function () {
        return require("private-next-pages/destinations/adestra.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adestra"])
      });
    }
  